export const YM_ID = Number(process.env.REACT_APP_YM_ID);
export const COOKIE_KEY = "cookie_consent";

const METRIKA_STATE_KEY = "__neurosferaMetrikaState";

function getMetrikaState() {
  if (!window[METRIKA_STATE_KEY]) {
    window[METRIKA_STATE_KEY] = {
      initialized: false,
      firstHitSent: false,
    };
  }

  return window[METRIKA_STATE_KEY];
}

export function hasMetrikaConsent() {
  return localStorage.getItem(COOKIE_KEY) === "accepted";
}

export function hasValidMetrikaId() {
  return Number.isInteger(YM_ID) && YM_ID > 0;
}

export function bootstrapYm() {
  if (typeof window.ym === "function") return;

  const ym = function () {
    (ym.a = ym.a || []).push(arguments);
  };

  ym.l = Date.now();
  window.ym = ym;
}

export function loadMetrikaScriptOnce() {
  if (document.getElementById("ym-tag")) return;

  const script = document.createElement("script");
  script.id = "ym-tag";
  script.async = true;
  script.src = "https://mc.yandex.ru/metrika/tag.js";
  document.head.appendChild(script);
}

export function trackPageView(path) {
  if (!hasValidMetrikaId() || !hasMetrikaConsent() || typeof window.ym !== "function") return;

  window.ym(YM_ID, "hit", path);
}

export function trackWebVital(metric) {
  if (!hasValidMetrikaId() || !hasMetrikaConsent() || typeof window.ym !== "function") return;

  window.ym(YM_ID, "reachGoal", "web_vital", {
    metricName: metric.name,
    metricValue: Math.round(metric.value),
    metricId: metric.id,
    metricDelta: Math.round(metric.delta),
    metricRating: metric.rating,
  });
}

export function enableMetrika() {
  if (!hasValidMetrikaId()) return;

  const state = getMetrikaState();

  bootstrapYm();
  loadMetrikaScriptOnce();

  if (!state.initialized) {
    window.ym(YM_ID, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
    });
    state.initialized = true;
  }

  if (!state.firstHitSent) {
    trackPageView(window.location.pathname + window.location.search);
    state.firstHitSent = true;
  }
}
